import { InlineAlert } from '../../../components/InlineAlert'

export interface ErrorStateProps {
  message: string
  onRetry: () => void
}

/** Never renders a broken table under an error — this replaces the grid body entirely. */
export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div style={{ padding: 'var(--iw-space-5)' }}>
      <InlineAlert
        severity="error"
        action={
          <button type="button" className="iw-btn iw-btn--sm" onClick={onRetry}>
            Try again
          </button>
        }
      >
        {message}
      </InlineAlert>
    </div>
  )
}
